import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useCountryPricingRuleQuery } from 'api';

export const useClientTypePricingRules = () => {
  const [addModalState, setAddModalState] = useState<boolean>(false);
  const [clientTypePricingRuleId, setClientTypePricingRuleId] = useState<string | undefined>(undefined);
  const { id } = useParams() as { id: string };
  const { data = {} } = useCountryPricingRuleQuery({ countryId: id });

  const onAddModalStateChange = useCallback(() => {
    setAddModalState((prevState) => !prevState);
  }, []);
  const onDeleteModalStateChange = useCallback((id?: string) => {
    setClientTypePricingRuleId(id);
  }, []);
  return {
    addModalState,
    clientTypePricingRuleId,
    onAddModalStateChange,
    onDeleteModalStateChange,
    clientTypeData: data?.clientTypePricingRulesList || [],
  };
};
